module.exports = __webpack_public_path__ + "img/96.e06e4d9c.png";